import {AplusBleDeviceProtocol, AplusDeviceProvide, AplusMqttDeviceProtocol} from "@hybird/device/terminal/aplus";
import {CompositeDeviceProtocol} from "@hybird/core/device/protocol";
import {DeviceType} from "@hybird/device/config";
import {
  BleV2DeviceProtocol,
  BleV2DeviceProtocolBeginSeal,
  BleV2DeviceProtocolOperation
} from "@hybird/device/protocol/blev2";
import {WebError} from "@hybird/core/error";
import {deviceError} from "@hybird/device/deviceError";
import {
  SerialDeviceProtocol,
  SerialDeviceProtocolBeginSeal,
  SerialDeviceProtocolOperation
} from "@hybird/device/protocol/serialAplus";

class AplusV2DeviceProvide extends AplusDeviceProvide {

  _deviceProtocols = {
    2: AplusMqttDeviceProtocol,
    1: AplusBleV2CompositeDeviceProtocol,
    3: AplusV2CompositeDeviceProtocol,
    4: AplusSerialDeviceProtocol
  };

  constructor(deviceConnectProvide) {
    super(deviceConnectProvide);
  }

  isSupport(deviceInfo) {
    return DeviceType.aplus === deviceInfo.modelType;
  }
}

class AplusV2CompositeDeviceProtocol extends CompositeDeviceProtocol {

  constructor(deviceProvide, deviceInfo, deviceProtocolOption) {
    super(deviceProvide, deviceInfo, deviceProtocolOption);
  }

  get connectPromiseType() {
    return 2;
  }

  get deviceProtocols() {
    return {
      4: AplusSerialDeviceProtocol,
      2: AplusMqttDeviceProtocol,
      1: AplusBleV2DeviceProtocol
    };
  }
}


class AplusBleV2CompositeDeviceProtocol extends CompositeDeviceProtocol {

  constructor(deviceProvide, deviceInfo, deviceProtocolOption) {
    super(deviceProvide, deviceInfo, deviceProtocolOption);
  }

  get connectPromiseType() {
    return 2;
  }

  get deviceProtocols() {
    return [
      AplusBleV2DeviceProtocol,
      AplusBleDeviceProtocol
    ];
  }

  get connectType() {
    return 1;
  }
}

class AplusBleV2DeviceProtocol extends BleV2DeviceProtocol {

  constructor(deviceProvide, deviceInfo, deviceProtocolOption) {
    super(deviceProvide, deviceInfo, deviceProtocolOption);
  }

  _createDeviceProtocolBeginSeal(option) {
    return new AplusBleV2DeviceProtocolBeginSeal(this.deviceInfo, this, option);
  }

  _createDeviceProtocolOperation() {
    return new AplusBleV2DeviceProtocolOperation(this.deviceInfo, this);
  }
}

class AplusBleV2DeviceProtocolBeginSeal extends BleV2DeviceProtocolBeginSeal {
  constructor(deviceInfo, deviceProtocol, option) {
    super(deviceInfo, deviceProtocol, option);
  }
}

class AplusBleV2DeviceProtocolOperation extends BleV2DeviceProtocolOperation {
  constructor(deviceInfo, deviceProtocol) {
    super(deviceInfo, deviceProtocol);
  }
}


class AplusSerialDeviceProtocol extends SerialDeviceProtocol {

  constructor(deviceProvide, deviceInfo, deviceProtocolOption) {
    super(deviceProvide, deviceInfo, deviceProtocolOption);
  }

  _createDeviceProtocolBeginSeal(option) {
    return new AplusSerialDeviceProtocolBeginSeal(this.deviceInfo, this, option);
  }

  _createDeviceProtocolOperation() {
    return new AplusSerialDeviceProtocolOperation(this.deviceInfo, this);
  }
}

class AplusSerialDeviceProtocolBeginSeal extends SerialDeviceProtocolBeginSeal {
  constructor(deviceInfo, deviceProtocol, option) {
    super(deviceInfo, deviceProtocol, option);
  }
}

class AplusSerialDeviceProtocolOperation extends SerialDeviceProtocolOperation {
  constructor(deviceInfo, deviceProtocol) {
    super(deviceInfo, deviceProtocol);
  }
}

export {AplusV2DeviceProvide};